import { render, staticRenderFns } from "./receiveCardError.vue?vue&type=template&id=5d7d9782&scoped=true&"
import script from "./receiveCardError.vue?vue&type=script&lang=js&"
export * from "./receiveCardError.vue?vue&type=script&lang=js&"
import style0 from "./receiveCardError.vue?vue&type=style&index=0&id=5d7d9782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d9782",
  null
  
)

export default component.exports